import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IResponse } from "../../../interfaces/response.interface";
import { environment } from "../../../../environments/environment";
import { IGetlogInParams } from "./interfaces/geLogInParams.interface";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient) {}

  logIn(params: IGetlogInParams): Observable<IResponse> {
    const { email, password, type } = params;
  
    const body = {
      email,
      password,
      type
    };
  
    return this.http.post<IResponse>(`${environment.API_DOMAINS.LOGIN}`, body);
  }

  tokenRefresh(token: string) {
    let user: any = localStorage.getItem("user");
    user = JSON.parse(user);
    user.token = token;
    user = JSON.stringify(user);
    localStorage.setItem("user", user);
  }
}
